import { IterableChangeRecord, IterableDiffer, IterableDiffers, TemplateRef, ViewContainerRef, ViewRef } from '@angular/core';
var ListForDirective = /** @class */ (function () {
    function ListForDirective(templateRef, viewContainer, differs) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.differs = differs;
        this.items = [];
        this.viewRefsMap = new Map();
        this.itemsAtOnce = 10;
        this.intervalLength = 50;
    }
    Object.defineProperty(ListForDirective.prototype, "appListForOf", {
        set: function (items) {
            this.items = items;
            if (items) {
                this._diffrence = this.differs.find(items).create();
            }
            //Clear any existing items
            this.viewContainer.clear();
        },
        enumerable: true,
        configurable: true
    });
    ListForDirective.prototype.ngDoCheck = function () {
        var _this = this;
        if (this._diffrence) {
            var changes = this._diffrence.diff(this.items);
            if (changes) {
                var itemsAdded_1 = [];
                changes.forEachAddedItem(function (item) {
                    itemsAdded_1.push(item);
                });
                this.progressiveRender(itemsAdded_1);
                changes.forEachRemovedItem(function (item) {
                    var mapView = _this.viewRefsMap.get(item.item);
                    var viewIndex = _this.viewContainer.indexOf(mapView);
                    _this.viewContainer.remove(viewIndex);
                    _this.viewRefsMap.delete(item.item);
                });
            }
        }
    };
    ListForDirective.prototype.progressiveRender = function (items) {
        var _this = this;
        var interval;
        var start = 0;
        var end = start + this.itemsAtOnce;
        if (end > items.length) {
            end = items.length;
        }
        this.renderItems(items, start, end);
        interval = setInterval(function () {
            start = end;
            end = start + _this.itemsAtOnce;
            if (end > items.length) {
                end = items.length;
            }
            _this.renderItems(items, start, end);
            if (start >= items.length) {
                clearInterval(interval);
            }
        }, this.intervalLength);
    };
    ListForDirective.prototype.renderItems = function (items, start, end) {
        var _this = this;
        items.slice(start, end).forEach(function (item) {
            var embeddedView = _this.viewContainer.createEmbeddedView(_this.templateRef, {
                $implicit: item.item
            }, item.currentIndex || 0);
            _this.viewRefsMap.set(item.item, embeddedView);
        });
    };
    return ListForDirective;
}());
export { ListForDirective };
